import React, { useState, useEffect, useContext } from "react";
import BannerSalon from "../../assets/showcases/salon-banner.jpg";
import BannerTrainer from "../../assets/showcases/trainer-banner.png";
import BannerBarber from "../../assets/showcases/barber-banner.png";
import { Avatar, Box, Button, Typography, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import Service1 from "../../assets/showcases/salon/service1.jpeg";
import Service2 from "../../assets/showcases/salon/service2.jpeg";
import Service3 from "../../assets/showcases/salon/service3.jpeg";
import Service4 from "../../assets/showcases/salon/service4.jpeg";
import Service5 from "../../assets/showcases/salon/service5.jpeg";
import Service6 from "../../assets/showcases/salon/service6.jpeg";
import Service7 from "../../assets/showcases/salon/service7.jpeg";
import Service8 from "../../assets/showcases/salon/service8.jpg";
import Service9 from "../../assets/showcases/salon/service9.jpg";
import Service10 from "../../assets/showcases/salon/service10.jpg";

import ServiceBarber1 from "../../assets/showcases/barber/service1.jpg";
import ServiceBarber2 from "../../assets/showcases/barber/service2.jpg";
import ServiceBarber3 from "../../assets/showcases/barber/service3.jpg";
import ServiceBarber4 from "../../assets/showcases/barber/service4.jpg";
import ServiceBarber5 from "../../assets/showcases/barber/service5.jpg";
import ServiceBarber6 from "../../assets/showcases/barber/service6.jpg";
import ServiceBarber7 from "../../assets/showcases/barber/service7.jpg";

import ServiceTrainer1 from "../../assets/showcases/trainer/service1.jpg";
import ServiceTrainer2 from "../../assets/showcases/trainer/service2.jpg";
import ServiceTrainer3 from "../../assets/showcases/trainer/service3.jpg";
import ServiceTrainer4 from "../../assets/showcases/trainer/service4.jpg";
import ServiceTrainer5 from "../../assets/showcases/trainer/service5.jpg";
import ServiceTrainer6 from "../../assets/showcases/trainer/service6.jpg";
import ServiceTrainer7 from "../../assets/showcases/trainer/service7.jpg";

import ServiceBarberCategories1 from "../../assets/showcases/barber/categoriesService1.jpg";
import ServiceBarberCategories2 from "../../assets/showcases/barber/categoriesService2.jpg";

import ServiceCategories1 from "../../assets/showcases/salon/categoriesService1.jpeg";
import ServiceCategories2 from "../../assets/showcases/salon/categoriesService2.jpeg";
import ServiceCategories3 from "../../assets/showcases/salon/categoriesService3.jpeg";
import ServiceCategories4 from "../../assets/showcases/salon/categoriesService4.jpeg";
import ServiceCategories5 from "../../assets/showcases/salon/categoriesService4.jpeg";
import { useSwipeable } from "react-swipeable";
import { CreatorContext } from "../../context/CreatorContext";
import chroma from "chroma-js";

const ShowcaseLayout = ({
	sector,
	layoutType,
	showBanner,
	showSearch,
	homeProductType,
	homeListType,
	homeShowSearch,
	homeShowStickyHeader,
	homeShowBigCarrousel,
	homeShowBigOverlayCarrousel,
	homeShowBanners,
	homeShowPadding,
	homeProductBackgroundColor,
	homeCategory,
	homeShowNews,
	homeShowFeatured,
	homeNewStyle,
	homeFeatureStyle,
}) => {
	const { t } = useTranslation();
	const [content, setContent] = useState(null);
	const [currentIndex, setCurrentIndex] = useState(0);

	const [selectedCategory, setSelectedCategory] = useState(
		t("homeServices.mostPopular")
	);

	const { creator } = useContext(CreatorContext);

	console.log(homeProductType);
	useEffect(() => {
		const loadContent = () => {
			switch (sector) {
				case "barber":
					return {
						banner: BannerBarber,
						services: [
							{
								name: t("homeServices.haircut"),
								duration: t("homeServices.duration30Minutes"),
								price: "€20.00",
								image: ServiceBarber1,
							},
							{
								name: t("homeServices.beardTrim"),
								duration: t("homeServices.duration20Minutes"),
								price: "€15.00",
								image: ServiceBarber2,
							},
							{
								name: t("homeServices.styling"),
								duration: t("homeServices.duration30Minutes"),
								price: "€25.00",
								image: ServiceBarber3,
							},
							{
								name: t("homeServices.hairColoring"),
								duration: t("homeServices.duration60Minutes"),
								price: "€45.00",
								image: ServiceBarber4,
							},
						],
						featuredServices: [
							{
								name: t("homeServices.haircut"),
								price: "€25.00",
								image: ServiceBarber5,
							},
							{
								name: t("homeServices.beardTrim"),
								price: "€15.00",
								image: ServiceBarber6,
							},
							{
								name: t("homeServices.styling"),
								price: "€20.00",
								image: ServiceBarber7,
							},
						],
						newsServices: [
							{
								name: t("homeServices.hairColoring"),
								price: "€45.00",
								image: ServiceBarber3,
							},
							{
								name: t("homeServices.dye"),
								price: "€10.00",
								image: ServiceBarber2,
							},
						],
						categories: [
							{
								name: t("homeServices.mostPopular"),
								image: ServiceBarberCategories2,
							},
							{
								name: t("homeServices.haircut"),
								image: ServiceBarber3,
							},
							{
								name: t("homeServices.beard"),
								image: ServiceBarberCategories1,
							},
							{
								name: t("homeServices.treatments"),
								image: ServiceBarber2,
							},
							{
								name: t("homeServices.others"),
								image: ServiceBarber2,
							},
						],
					};

				case "salon":
					return {
						banner: BannerSalon,
						services: [
							{
								name: t("homeServices.facialCleansing"),
								duration: t("homeServices.duration60Minutes"),
								price: "€30.00",
								image: Service1,
							},
							{
								name: t("homeServices.manicure"),
								duration: t("homeServices.duration30To60Minutes"),
								price: "€24.00 - €30.00",
								image: Service3,
							},
							{
								name: t("homeServices.pedicure"),
								duration: t("homeServices.duration60Minutes"),
								price: "€20.00",
								image: Service5,
							},
							{
								name: t("homeServices.relaxingMassage"),
								duration: t("homeServices.duration90Minutes"),
								price: "€50.00",
								image: Service6,
							},
							{
								name: t("homeServices.eyebrowThreading"),
								duration: t("homeServices.duration10Minutes"),
								price: "€10.00",
								image: Service7,
							},
						],
						featuredServices: [
							{
								name: t("homeServices.pedicure"),
								price: "€30.00",
								image: Service1,
							},
							{
								name: t("homeServices.relaxingMassage"),
								price: "€32.00",
								image: Service2,
							},
							{
								name: t("homeServices.threadWaxing"),
								price: "€10.00",
								image: Service3,
							},
						],
						newsServices: [
							{
								name: t("homeServices.facialCleaning"),
								price: "€40.00",
								image: Service4,
							},
							{
								name: t("homeServices.bodyScrub"),
								price: "€50.00",
								image: Service5,
							},
						],
						categories: [
							{
								name: t("homeServices.mostPopular"),
								image: ServiceCategories1,
							},
							{ name: t("homeServices.nails"), image: ServiceCategories2 },
							{
								name: t("homeServices.hairRemoval"),
								image: ServiceCategories3,
							},
							{ name: t("homeServices.face"), image: ServiceCategories4 },
							{ name: t("homeServices.massage"), image: ServiceCategories5 },
						],
					};

				case "trainer":
					return {
						banner: BannerTrainer,
						services: [
							{
								name: t("homeServices.personalTraining"),
								duration: t("homeServices.duration60Minutes"),
								price: "€50.00",
								image: ServiceTrainer1,
							},
							{
								name: t("homeServices.nutritionConsultation"),
								duration: t("homeServices.duration45Minutes"),
								price: "€40.00",
								image: ServiceTrainer4,
							},
							{
								name: t("homeServices.onlineTraining"),
								duration: t("homeServices.duration60Minutes"),
								price: "€30.00",
								image: ServiceTrainer2,
							},
							{
								name: t("homeServices.groupTraining"),
								duration: t("homeServices.duration90Minutes"),
								price: "€25.00",
								image: ServiceTrainer3,
							},
						],
						featuredServices: [
							{
								name: t("homeServices.personalTraining"),
								price: "$50.00",
								image: ServiceTrainer5,
							},
							{
								name: t("homeServices.groupTraining"),
								price: "$30.00",
								image: ServiceTrainer6,
							},
							{
								name: t("homeServices.nutritionConsultation"),
								price: "$40.00",
								image: ServiceTrainer7,
							},
						],
						newsServices: [
							{
								name: t("homeServices.weightLossProgram"),
								price: "$150.00",
								image: ServiceTrainer1,
							},
							{
								name: t("homeServices.strengthTraining"),
								price: "$60.00",
								image: ServiceTrainer2,
							},
						],
						categories: [
							{
								name: t("homeServices.mostPopular"),
								image: ServiceTrainer2,
							},
							{
								name: t("homeServices.personalTraining"),
								duration: t("homeServices.duration60Minutes"),
								price: "€50.00",
								image: ServiceTrainer1,
							},
							{
								name: t("homeServices.onlineTraining"),
								image: ServiceTrainer5,
							},
							{ name: t("homeServices.nutrition"), image: ServiceTrainer4 },
						],
					};

				default:
					return {};
			}
		};

		setContent(loadContent());
	}, [sector, t]);

	const handlers = useSwipeable({
		onSwipedLeft: () => handleNext(),
		onSwipedRight: () => handlePrev(),
		preventScrollOnSwipe: true,
		trackMouse: true,
	});

	const handleNext = () => {
		if (content && content.categories) {
			setCurrentIndex(
				(prevIndex) => (prevIndex + 1) % content.categories.length
			);
		}
	};

	const handlePrev = () => {
		if (content && content.categories) {
			setCurrentIndex((prevIndex) =>
				prevIndex === 0 ? content.categories.length - 1 : prevIndex - 1
			);
		}
	};

	const getTextColorBasedOnBackground = (bgColor) => {
		const r = parseInt(bgColor.substring(1, 3), 16);
		const g = parseInt(bgColor.substring(3, 5), 16);
		const b = parseInt(bgColor.substring(5, 7), 16);
		const brightness = (r * 299 + g * 587 + b * 114) / 1000;
		return brightness > 128 ? "#000000" : "#FFF";
	};

	return (
		<Box
			sx={{
				position: "relative",
				"& *": {
					fontFamily: creator.fontFamilyCap + "!important",
				},
			}}
		>
			{showBanner && content && content.banner && (
				<img
					alt={t("homeServices.bannerAlt")}
					src={content.banner}
					style={{ width: "100%" }}
					draggable={false}
				/>
			)}
			{homeShowFeatured && content && content.featuredServices && (
				<Box sx={{ padding: 1, paddingTop: 0 }}>
					<Typography
						variant="body2"
						sx={{
							fontSize: 7,
							marginBottom: 0.5,
							fontFamily: creator.fontFamilyCap + "!important",
						}}
					>
						{t("homeServices.featured")}
					</Typography>
					<Box
						sx={{
							display: "flex",
							overflowX: "auto",
							gap: homeFeatureStyle === "featureStyle2" ? 3 : 1,
							marginLeft: homeFeatureStyle === "featureStyle2" ? 2 : 0,
						}}
					>
						{content.featuredServices.map((service, index) => (
							<Box
								key={index}
								sx={{
									display: "flex",
									flexDirection: "column",
									position: "relative",
									alignItems:
										homeFeatureStyle === "featureStyle2"
											? "center"
											: "flex-start",
								}}
							>
								<img
									src={service.image}
									alt={service.name}
									style={{
										width: homeFeatureStyle === "featureStyle2" ? 50 : 70,
										height:
											homeFeatureStyle === "featureStyle2"
												? 50
												: homeFeatureStyle === "featureStyle3"
												? 100
												: 70,
										objectFit: "cover",
										borderRadius: homeFeatureStyle === "featureStyle2" ? 30 : 0,
									}}
								/>
								<Box
									sx={{
										position:
											homeFeatureStyle === "featureStyle4"
												? "absolute"
												: "relative",
										display: "flex",
										flexDirection: "column",
										justifyContent:
											homeFeatureStyle === "featureStyle4"
												? "center"
												: "inherit",
										alignItems:
											homeFeatureStyle === "featureStyle4"
												? "center"
												: "inherit",
										backgroundColor:
											homeFeatureStyle === "featureStyle4"
												? "rgba(0, 0, 0, 0.6)"
												: "none",
										color:
											homeFeatureStyle === "featureStyle4"
												? "#ffffff"
												: "inherit",
										top: 0,
										left: 0,
										right: 0,
										bottom: 0,
									}}
								>
									<Typography
										variant="body2"
										sx={{
											textAlign:
												homeFeatureStyle === "featureStyle2"
													? "center"
													: "left",
											fontSize: 7,
											marginTop: 0.5,
											whiteSpace: "nowrap", // Mantiene el texto en una línea
											overflow: "hidden", // Oculta el desbordamiento
											textOverflow: "ellipsis", // Añade "..." al final si el texto es demasiado largo
											maxWidth: homeFeatureStyle === "featureStyle2" ? 70 : 70,
										}}
									>
										{service.name}
									</Typography>
									<Typography
										variant="body2"
										sx={{
											fontWeight: "bold",
											textAlign:
												homeFeatureStyle === "featureStyle2"
													? "center"
													: "left",
											fontSize: 7,
										}}
									>
										{service.price}
									</Typography>
								</Box>
							</Box>
						))}
					</Box>
				</Box>
			)}

			{homeShowNews && content && content.newsServices && (
				<Box sx={{ padding: 1, paddingTop: 0 }}>
					<Typography variant="body2" sx={{ fontSize: 7, marginBottonm: 0.5 }}>
						{t("homeServices.news")}
					</Typography>
					<Box
						sx={{
							display: "flex",
							gap: homeNewStyle === "newStyle2" ? 3 : 1,
							marginLeft: homeNewStyle === "newStyle2" ? 2 : 0,
							overflowX: "auto",
						}}
					>
						{content.newsServices.map((service, index) => (
							<Box
								key={index}
								sx={{
									display: "flex",
									flexDirection: "column",
									position: "relative",
									alignItems:
										homeNewStyle === "newStyle2" ? "center" : "flex-start",
								}}
							>
								<img
									src={service.image}
									alt={service.name}
									style={{
										width: homeNewStyle === "newStyle2" ? 50 : 70,
										height:
											homeNewStyle === "newStyle2"
												? 50
												: homeNewStyle === "newStyle3"
												? 100
												: 70,
										objectFit: "cover",
										borderRadius: homeNewStyle === "newStyle2" ? 30 : 0,
									}}
								/>
								<Box
									sx={{
										position:
											homeNewStyle === "newStyle4" ? "absolute" : "relative",
										display: "flex",
										flexDirection: "column",
										justifyContent:
											homeNewStyle === "newStyle4" ? "center" : "inherit",
										alignItems:
											homeNewStyle === "newStyle4" ? "center" : "inherit",
										backgroundColor:
											homeNewStyle === "newStyle4"
												? "rgba(0, 0, 0, 0.6)"
												: "none",
										color: homeNewStyle === "newStyle4" ? "#ffffff" : "inherit",
										top: 0,
										left: 0,
										right: 0,
										bottom: 0,
									}}
								>
									<Typography
										variant="body2"
										sx={{
											textAlign:
												homeFeatureStyle === "featureStyle2"
													? "center"
													: "left",
											fontSize: 7,
											marginTop: 0.5,
											whiteSpace: "nowrap", // Mantiene el texto en una línea
											overflow: "hidden", // Oculta el desbordamiento
											textOverflow: "ellipsis", // Añade "..." al final si el texto es demasiado largo
											maxWidth: homeFeatureStyle === "featureStyle2" ? 70 : 70,
										}}
									>
										{service.name}
									</Typography>
									<Typography
										variant="body2"
										sx={{
											fontWeight: "bold",
											textAlign:
												homeNewStyle === "featureStyle2" ? "center" : "left",
											fontSize: 7,
										}}
									>
										{service.price}
									</Typography>
								</Box>
							</Box>
						))}
					</Box>
				</Box>
			)}
			{homeProductType === "homeProduct1" ? (
				homeShowBigCarrousel ? (
					<Box sx={{ padding: homeShowPadding ? 1 : 0 }}>
						<Box
							{...handlers}
							sx={{
								display: "flex",
								flexDirection: "column",
								alignItems: "center",
								width: "100%",
								maxWidth: 360, // Limita el ancho máximo del carrusel
								height: showBanner ? 230 : "100%", // Ajusta la altura del carrusel
								overflow: "hidden",
								marginTop: homeShowPadding ? "-7px" : "0px",
							}}
						>
							<Box
								sx={{
									display: "flex",
									transition: "transform 0.5s ease",
									transform: `translateX(-${currentIndex * 100}%)`,
									width: `${200 * 100}%`,
								}}
							>
								{content &&
									content.categories.map((category, index) => (
										<Box
											key={index}
											sx={{
												flex: "0 0 100%",
												display: "flex",
												flexDirection: "column",
												alignItems: "center",
												overflow: "hidden",
											}}
										>
											<img
												src={category.image}
												alt={category.name}
												style={{
													width: 200,
													height: showBanner ? 160 : 300,
													objectFit: "cover",
												}}
											/>
											<Typography
												variant="body1"
												sx={{
													fontWeight: "bold",
													fontSize: 10,
													textAlign: "center",
													marginTop: 1,
												}}
											>
												{category.name}
											</Typography>
										</Box>
									))}
							</Box>
							{/* Indicador de paginación */}
							<Box
								sx={{
									display: "flex",
									justifyContent: "center",
									alignItems: "center",
									marginTop: 1,
								}}
							>
								{content &&
									content.categories.map((_, index) => (
										<Box
											key={index}
											sx={{
												width: 3,
												height: 3,
												borderRadius: "50%",
												backgroundColor:
													index === currentIndex ? "#000000" : "#ddd",
												marginX: 0.5,
											}}
										/>
									))}
							</Box>
						</Box>
					</Box>
				) : (
					homeShowBigOverlayCarrousel && (
						<Box sx={{ padding: homeShowPadding ? 1 : 0 }}>
							<Box sx={{ position: "relative" }}>
								<Box sx={{ marginTop: homeShowPadding ? "-7px" : "0px" }}>
									<img
										src={content.categories[0].image}
										alt={content.categories[0].name}
										style={{
											width: "100%",
											height: showBanner ? 200 : 350,
											objectFit: "cover",
										}}
									/>
									<Box
										sx={{
											position: "absolute",
											bottom: 32,
											left: 0,
											right: 0,
											textAlign: "center",
										}}
									>
										<Typography
											variant="body1"
											sx={{
												fontWeight: "bold",
												fontSize: 12,
												textAlign: "center",
												marginTop: 1,
											}}
										>
											{content.categories[0].name}
										</Typography>
									</Box>
								</Box>
								{/* Indicador de paginación */}
								<Box
									sx={{
										position: "absolute",
										left: 8,
										top: "50%",
										transform: "translateY(-50%)",
										display: "flex",
										flexDirection: "column",
										alignItems: "center",
										gap: 1,
									}}
								>
									{content &&
										content.categories.map((_, index) => (
											<Box
												key={index}
												sx={{
													width: 4,
													height: 4,
													borderRadius: "50%",
													backgroundColor:
														index === currentIndex ? "#000000" : "#ddd",
													marginBottom: 1,
												}}
											/>
										))}
								</Box>
							</Box>
						</Box>
					)
				)
			) : homeCategory === true ? (
				<Grid container spacing={2} sx={{ padding: 2 }}>
					{content &&
						content.categories.map((category, index) => (
							<Grid item xs={6} sm={6} key={index}>
								<Box
									sx={{
										display: "flex",
										flexDirection: "column",
										alignItems: "center",

										overflow: "hidden",
									}}
								>
									<img
										src={category.image}
										alt={category.name}
										style={{
											width: 60,
											height: 60,
											objectFit: "cover",
											borderRadius: 0,
										}}
									/>
									<Typography
										variant="body2"
										sx={{
											fontWeight: "bold",
											fontSize: 10,
											textAlign: "center",
											marginTop: 1,
										}}
									>
										{category.name}
									</Typography>
								</Box>
							</Grid>
						))}
				</Grid>
			) : (
				<>
					<Box
						sx={{
							display: "flex",
							overflowX: "auto",
							height: 20,
							marginBottom:
								homeProductType === "homeProduct4" ||
								homeProductType === "homeProduct2"
									? 1
									: 0,
							marginTop: showBanner ? 0 : 1,
						}}
					>
						{content &&
							content.categories.map((category, index) => (
								<Button
									key={index}
									variant="text"
									disableRipple={true}
									disableElevation={true}
									sx={{
										height: 20,
										paddingX: 2,
										paddingRight: 0,
										paddingLeft: 1,
										minWidth: "auto",

										fontWeight:
											selectedCategory === category.name ? "bold" : "normal",
										color:
											selectedCategory === category.name
												? creator.themeMode === "Dark"
													? "#ffffff"
													: "#000000"
												: creator.themeMode === "Dark"
												? chroma(creator.themeColor).brighten(2).hex()
												: chroma(creator.themeColor).darken(2).hex(),
										whiteSpace: "nowrap",
										textTransform: "none",
										fontSize: 8,
										"&:hover": {
											backgroundColor: "transparent",
										},
									}}
								>
									{category.name}
								</Button>
							))}
					</Box>
					<Box sx={{ flex: 1 }}>
						{(homeProductType === "homeProduct5" ||
							homeProductType === "homeProduct6") && (
							<Box
								sx={{
									display: "flex",
									flexDirection: "column",
									gap: 1,
									padding: 1,
								}}
							>
								{content &&
									content.services.map((service, index) => (
										<Box
											sx={{
												display: "flex",
												flexDirection: "row",
												backgroundColor:
													homeProductType === "homeProduct6"
														? "none"
														: homeProductBackgroundColor
														? homeProductBackgroundColor
														: "#f9f9f9",
												borderRadius:
													homeProductType === "homeProduct5" ? 2 : 0,
												justifyContent: "space-between",
												width: "100%",
												padding: 1,
												borderBottom:
													homeProductType === "homeProduct5"
														? "none"
														: `1px solid ${
																creator.themeMode === "Dark"
																	? chroma(creator.themeColor).brighten(1).hex()
																	: chroma(creator.themeColor).darken(0.5).hex()
														  }`,
											}}
										>
											<Box
												sx={{
													display: "flex",
													flexDirection: "column",
												}}
											>
												<Typography
													variant="body1"
													sx={{
														fontWeight: "bold",
														fontSize: 8,
														color:
															homeProductType === "homeProduct5"
																? getTextColorBasedOnBackground(
																		homeProductBackgroundColor
																  )
																: creator.themeMode === "Dark"
																? "#ffffff"
																: "#000000",
													}}
												>
													{service.name}
												</Typography>
												<Typography
													variant="body2"
													sx={{
														fontSize: 8,
														color:
															homeProductType === "homeProduct5"
																? getTextColorBasedOnBackground(
																		homeProductBackgroundColor
																  )
																: creator.themeMode === "Dark"
																? "#ffffff"
																: "#000000",
													}}
												>
													{service.duration}
												</Typography>
											</Box>
											<Box>
												<Typography
													variant="body2"
													sx={{
														fontWeight: "bold",
														fontSize: 8,
														textAlign: "right",
														color:
															homeProductType === "homeProduct5"
																? getTextColorBasedOnBackground(
																		homeProductBackgroundColor
																  )
																: creator.themeMode === "Dark"
																? "#ffffff"
																: "#000000",
													}}
												>
													{service.price}
												</Typography>
											</Box>
										</Box>
									))}
							</Box>
						)}

						{homeProductType === "homeProduct4" &&
							content &&
							content.services.map((service, index) => (
								<Box
									sx={{
										display: "flex",
										alignItems: "center",
										flex: 1,
										marginBottom: homeShowPadding ? 0.5 : 0,
									}}
								>
									<Avatar
										src={service.image}
										alt={service.name}
										sx={{
											width: 50,
											height: 50,
											marginRight: 2,
											marginLeft: homeShowPadding ? 1 : 0,
											marginBottom: homeShowPadding ? 1 : 0,
											borderRadius: homeListType === "rounded" ? "40px" : "0px",
										}}
									/>
									<Box>
										<Typography
											variant="body1"
											sx={{
												fontWeight: "bold",
												fontSize: 8,
											}}
										>
											{service.name}
										</Typography>
										<Typography variant="body2" sx={{ fontSize: 8 }}>
											{service.duration}
										</Typography>
										<Typography
											variant="body2"
											sx={{
												fontWeight: "bold",
												marginTop: "0px",
												fontSize: 8,
											}}
										>
											{service.price}
										</Typography>
									</Box>
								</Box>
							))}

						{homeProductType === "homeProduct2" &&
							content &&
							content.services.map((service, index) => (
								<Box
									sx={{
										display: "flex",
										alignItems: "flex-start",
										flexDirection: "column",
										flex: 1,
										padding: 0,
										paddingLeft: homeShowPadding ? 1 : 0,
										paddingRight: homeShowPadding ? 1 : 0,
									}}
								>
									<img
										src={service.image}
										alt={service.name}
										style={{
											width: "100%",
											height: "120px",
											objectFit: "cover",
										}}
									/>
									<Box
										sx={{
											paddingBottom: 1,
											paddingLeft: homeShowPadding ? 0 : 1,
											paddingRight: homeShowPadding ? 0 : 1,
										}}
									>
										<Typography
											variant="body1"
											sx={{ fontSize: 8, textAlign: "left", marginTop: 1 }}
										>
											{service.name}
										</Typography>
										<Typography
											variant="body2"
											sx={{
												fontSize: 8,
												textAlign: "left",
												fontWeight: "bold",
											}}
										>
											{service.price}
										</Typography>
									</Box>
								</Box>
							))}

						{homeProductType === "homeProduct3" &&
							content &&
							content.services.map((service, index) => (
								<Box
									sx={{
										paddingLeft: homeShowPadding ? 1 : 0,
										paddingRight: homeShowPadding ? 1 : 0,
										paddingBottom: homeShowPadding ? 1 : 0,
									}}
								>
									<Box
										sx={{
											position: "relative",
											overflow: "hidden",
										}}
									>
										<img
											src={service.image}
											alt={service.name}
											style={{
												width: "100%",
												objectFit: "cover",
												display: "block",
												height: 100,
											}}
										/>
										<Box
											sx={{
												position: "absolute",
												bottom: 0,
												left: 0,
												right: 0,
												top: 0,
												backgroundColor: "rgba(0, 0, 0, 0.6)",
												color: "#ffffff",
												display: "flex",
												flexDirection: "column",
												alignItems: "center",
												justifyContent: "center",
												textAlign: "center",
											}}
										>
											<Typography variant="body1" sx={{ fontSize: 8 }}>
												{service.name}
											</Typography>
											<Typography
												variant="body2"
												sx={{ fontWeight: "bold", fontSize: 8 }}
											>
												{service.price}
											</Typography>
										</Box>
									</Box>
								</Box>
							))}
					</Box>
				</>
			)}
		</Box>
	);
};

export default ShowcaseLayout;
